import { useState } from 'react'
import { Link } from "react-router-dom"
import { clsfy } from '../helpers'
import Sidebar from '../components/Sidebar'
import Editor from '../components/Editor'

import { ReactComponent as DocumentIcon } from '../assets/svg/document.svg'

const Subheading = ({ children, className }) => (
	<div className={clsfy(className, 'text-lg font-bold leading-6 text-1b')}>
		{children}
	</div>
)

const DocumentListItem = ({ children, active }) => (
	<button className={clsfy('flex items-center text-base text-7d leading-5 space-x-2.5 transition-all font-bold hover:font-bold', {
		'font-bold': active
	})}>
		<DocumentIcon />
		<span>{children}</span>
	</button>
)

const EditorLayout = ({ children }) => {

	const [sidebarExpanded, setSidebarExpanded] = useState(false)
	const [routes] = useState([
		{
			path: "/grammar-report",
			name: "Grammar Report",
		},
		{
			path: "/sentence-variation",
			name: "Sentence Variation",
		},
		{
			path: "/paragraph-variation",
			name: "Paragraph Variation",
		},
		{
			path: "/suggestions",
			name: "Suggestions",
		},
		{
			path: "/sentiment-analysis",
			name: "Sentiment Analysis",
		},
		{
			path: "/pacing",
			name: "Pacing",
		},
		{
			path: "/chapter-variation",
			name: "Chapter Variation",
		},
		{
			path: "/adverbs",
			name: "Adverbs",
		},
		{
			path: "/cliches",
			name: "Cliches",
		},
		{
			path: "/redundancies",
			name: "Redundancies",
		},
		{
			path: "/tag-report",
			name: "Tag Report",
		},
		{
			path: "/unnecessary-filler",
			name: "Unnecessary Filler",
		},
		{
			path: "/generic-description",
			name: "Generic Description",
		},
		{
			path: "/showing-vs-telling",
			name: "Showing vs Telling",
		},
		{
			path: "/writing-style-report",
			name: "Writing Style eport",
		},
	]);

	return (
		<div className="flex flex-col h-screen">
			<div className="flex-1 flex overflow-hidden">
				<Sidebar
					logoutColor="#EF5D14"
					expanded={sidebarExpanded}
					onChange={(v) => setSidebarExpanded(v)}
				>
					<div className="flex flex-col px-5 2xl:px-6 flex-none">
						<Subheading>My Documents</Subheading>
						<div className="mt-3.5 pl-4 space-y-4">
							<DocumentListItem active>Early Life</DocumentListItem>
							<button className="flex items-center text-base text-7d leading-5 space-x-2.5 transition-all hover:font-bold">
								<DocumentIcon />
								<span>World War II</span>
							</button>
							<button className="flex items-center text-base text-7d leading-5 space-x-2.5 transition-all hover:font-bold">
								<DocumentIcon />
								<span>Career</span>
							</button>
							<button className="flex items-center space-x-1 text-ef font-bold text-base mt-4">
								<i className="mdi mdi-plus text-lg"></i>
								<span className="underline">New Document</span>
							</button>
						</div>
					</div>
					<hr className="my-5 border-t border-e4 flex-none" />
					<div className="flex-1 flex flex-col overflow-hidden">
						<Subheading className="flex-none px-5 2xl:px-6">Actions</Subheading>
						<div className="flex flex-col overflow-y-auto scrollbar-y">
							{routes.map((route, routeIndex) => (
								<Link
									key={routeIndex}
									to={"/editor" + route.path}
									className="xl:pl-8 2xl:pl-9 pr-5 xl:pr-6 2xl:pr-8 py-2 text-7d flex items-center justify-between"
								>
									<span>{route.name}</span>
									<i className="iconly-Arrow-Right-Circle icli text-xl"></i>
								</Link>
							))}
						</div>
					</div>
				</Sidebar>
				<div className='flex-1 flex flex-col'>
					<div className="px-5 pt-5 md:hidden">
						<button
							className="rounded w-8 h-8 grid place-items-center hover:bg-ef "
							onClick={() => setSidebarExpanded(true)}
						>
							<i className="mdi mdi-menu text-2xl text-7d hover:text-white"></i>
						</button>
					</div>
					<div className="flex-1 flex lg:p-5 xl:p-6 overflow-y-auto lg:space-x-5 xl:space-x-6 2xl:space-x-6 bg-f4">
						<Editor />
						<div className="flex-none hidden md:block md:max-w-md lg:max-w-lg 2xl:max-w-2xl w-full">
							<div className="lg:h-14 2xl:h-16"></div>
							<div className="lg:mt-5 2xl:mt-6 overflow-hidden">
								<div className="editor-scrollbar flex flex-col">
									{children}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="d-flex absolute  right-4 bottom-5 md:right-10 md:bottom-10">
				<button className="inline-flex items-center justify-center w-5 h-5 md:w-10 md:h-10 mr-2 md:mr-8  text-gray-700 transition-colors duration-150 bg-white rounded-full focus:shadow-outline hover:bg-gray-200">
					<span className="mdi mdi-help text-sm" />
				</button>
				<Link
					to="/editor"
					className="mt-4 w-36 md:w-48 h-8 md:h-12 bg-ef text-white font-bold md:py-2 px-2 md:px-4  inline-flex items-center rounded-xl"
				>
					<span className="mdi mdi-chat-outline text-xs md:text-xl pr-1 pl-3 md:pl-2" />
					<span className="text-xs md:text-base font-bold">
						New Document
					</span>
				</Link>
			</div>
		</div>
	);
}

export default EditorLayout